import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const termAndConditionSlice = createSlice({
  name: 'termAndCondition',
  initialState: {
    checked : false,
    consent: '',
    loading: false,
  },
  reducers: {
    setCheckedRedux: (state, action) => {
        const { checked } = action.payload
        state.checked = checked
      },
      setConsentRedux: (state, action) => {
        const { consent } = action.payload
        state.consent = consent
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
  },
})

export default termAndConditionSlice.reducer;

export const {
    setCheckedRedux,
    setConsentRedux,
    setLoadingRedux
} = termAndConditionSlice.actions

export const getCheckedRedux = (state) => state.termAndCondition.checked
export const getConsentRedux = (state) => state.termAndCondition.consent
export const getLoadingRedux = (state) => state.termAndCondition.loading
